import { KeycloakOptions, KeycloakService } from 'keycloak-angular';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';

const keycloakOptions: KeycloakOptions = {
  config: {
    url: environment.authServerUrl,
    realm: environment.realm,
    clientId: environment.resource,
  },
  initOptions: {
    onLoad: 'login-required',
    checkLoginIframe: false,
  },
  loadUserProfileAtStartUp: true,
  bearerExcludedUrls: ['/assets'],
};

export function initializer(
  keycloak: KeycloakService,
  userService: UserService
): () => Promise<void> {
  return async () => {
    try {
      await keycloak.init(keycloakOptions);

      const username =
        keycloak.getKeycloakInstance().tokenParsed?.preferred_username;

      if (username) {
        await userService.getUserRolesPermissions(username).toPromise();
      }
    } catch (err) {
      console.error(
        'Error durante la inicialización de Keycloak o la carga de permisos',
        err
      );
      throw err;
    }
  };
}
